<template>
  <div class="pg-criteria-form-drawer">
    <CollapseTransition>
      <PgForm
        @keyup.enter.native="search"
        v-show="showForm"
        id="PgCriteriaForm"
        :model="formData"
        :formItems="formItems"
        class="pg-criteria-form-drawer_form"
      >
      </PgForm>
    </CollapseTransition>
    <div class="pg-criteria-form-drawer_btn">
      <el-button type="primary" round @click="search">查询</el-button>
      <el-button type="danger" round @click="clear">清空</el-button>
      <el-button type="text" class="pg-criteria-form-drawer_btn-more" @click="handleOpen">
        {{ showForm ? '收起查询条件' : '展开查询条件'
        }}<i :class="{ 'el-icon-arrow-up': showForm, 'el-icon-arrow-down': !showForm }"></i
      ></el-button>
    </div>
  </div>
</template>
<script setup>
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
import { PgForm } from '../../form/index'
import { ref } from 'vue'

const emit = defineEmits(['search, clear'])

const props = defineProps({
  formData: Object, //form 值
  //form 的配置
  formItems: {
    type: [Array, Object],
    default: null,
  },
  open: {
    type: Boolean,
    default: true,
  },
})

// 展开收起
const showForm = ref(props.open) // false 收起  true:展开

const handleOpen = () => {
  showForm.value = !showForm.value
}

// 查询按钮
const search = () => {
  emit('search')
}

// 清空按钮
const clear = () => {
  emit('clear')
}
</script>
<style lang="scss">
@import '../style/criteria-form-drawer.scss';
</style>
